export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8459.94c59f4a.jpg";